/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    ROUTE_HELP_BUTTON
 * Date:         2026-07-13
 * Modified By:  Maya (UI/UX)
 *
 * Description:
 * Route-aware wrapper that renders a single FloatingHelpButton and points it
 * at the matching Help Center docs category based on the current path.
 * Mounted once inside the logged-in AppShell, so it covers every Inventory
 * and Broadcasts sub-route (list, create, edit, mine, details) without
 * duplicating the button on each page.
 *
 * File Size Check:
 * - Current: ~30 lines
 * - Decision: Proceed (well within component limit)
 *
 * Related Files:
 * - client/src/components/ui/FloatingHelpButton.tsx
 * - client/src/App.tsx
 */
import React from "react";
import { useLocation } from "react-router-dom";
import FloatingHelpButton from "./FloatingHelpButton";

const DOCS_BASE = "https://uavtradezone.com/docs-category";

const RouteHelpButton: React.FC = () => {
  const { pathname } = useLocation();

  if (pathname.startsWith("/inventory")) {
    return <FloatingHelpButton href={`${DOCS_BASE}/inventory/`} label="Inventory help" />;
  }
  if (pathname.startsWith("/broadcast") || pathname.startsWith("/allbroadcasts")) {
    return <FloatingHelpButton href={`${DOCS_BASE}/broadcasts/`} label="Broadcasts help" />;
  }
  return null;
};

export default RouteHelpButton;
